<app-navbar-apartment></app-navbar-apartment>
<main class="~space-y-8/24">
    <ng-container #viewContainerRef></ng-container>
</main>
<app-footer-apartment></app-footer-apartment>
